"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("./styles");
function MiniCard(_a) {
    var header = _a.header, children = _a.children, icon = _a.icon;
    return (react_1.default.createElement(styles_1.MainContainer, { hasIcon: !!icon },
        icon,
        icon ? (react_1.default.createElement(styles_1.ContentContainer, null,
            typeof header === "string" ? react_1.default.createElement(styles_1.Header, null, header) : header,
            children)) : (react_1.default.createElement(react_1.default.Fragment, null,
            typeof header === "string" ? react_1.default.createElement(styles_1.Header, null, header) : header,
            children))));
}
exports.default = MiniCard;
//# sourceMappingURL=index.js.map